module.exports = function() {
  return new Worker(__webpack_public_path__ + "252d63f663584390997c.worker.js");
};